import ChatMemoList from "./chat-memo-list";
import ChatMemoDetail from "./chat-memo-detail";
import type { ChatMemo } from "./types";
import ChatMemoForm from "./chat-memo-form";
import useChatMemoStore from "@/stores/chat-memo";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

interface ChatMemoDrawerProps {
  chatTitle: string;
  isOpen: boolean;
  onClose: () => void;
  memos: ChatMemo[];
  onDeleteMemo: (id: string) => void;
  onEditMemo: (memo: ChatMemo) => void;
}

const ChatMemoDrawer = ({
  chatTitle,
  isOpen,
  onClose,
  memos,
  onDeleteMemo,
  onEditMemo,
}: ChatMemoDrawerProps) => {
  const { id } = useParams();

  const setSelectedMemoId = useChatMemoStore(
    (state) => state.setSelectedMemoId
  );
  const setCurrentView = useChatMemoStore((state) => state.setCurrentView);
  const selectedMemoId = useChatMemoStore((state) => state.selectedMemoId);
  const currentView = useChatMemoStore((state) => state.currentView);

  const selectedMemo = memos.find((memo) => memo.id === selectedMemoId);

  const handleMemoClick = (memo: ChatMemo) => {
    setSelectedMemoId(memo.id);
    setCurrentView("detail");
  };

  const handleNewMemo = () => {
    setCurrentView("edit");
  };

  const handleBack = () => {
    setCurrentView("list");
    setSelectedMemoId(null);
  };

  const handleClose = () => {
    setCurrentView("list");
    setSelectedMemoId(null);
    onClose();
  };

  useEffect(() => {
    return () => {
      setCurrentView("list");
      setSelectedMemoId(null);
      onClose();
    };
  }, [id]);

  return (
    <div
      className={`pt-4 z-20 h-h-main-container border-l border-gray-200 bg-white transition-all duration-300 ease-in-out overflow-hidden ${
        isOpen ? "w-[398px] min-w-[398px] opacity-100" : "w-0 min-w-0 opacity-0"
      }`}
      style={{
        background: "rgba(252, 252, 252, 0.70)",
      }}
    >
      {currentView === "list" && (
        <ChatMemoList
          chatTitle={chatTitle}
          memos={memos}
          onMemoClick={handleMemoClick}
          onNewMemo={handleNewMemo}
          onClose={handleClose}
          onDeleteMemo={onDeleteMemo}
        />
      )}
      {currentView === "detail" && selectedMemo && (
        <ChatMemoDetail
          memo={selectedMemo}
          chatTitle={chatTitle}
          onBack={handleBack}
          onDelete={() => {
            onDeleteMemo(selectedMemo.id);
            handleBack();
          }}
          onEdit={(editedMemo) => {
            onEditMemo(editedMemo);
            setSelectedMemoId(editedMemo.id);
          }}
        />
      )}
      {/* 편집상태일때 Delete시 창 닫기 */}
      {currentView === "edit" && (
        <ChatMemoForm
          chatTitle={chatTitle}
          onBack={handleBack}
          onDelete={() => {
            handleBack();
          }}
          onEdit={(editedMemo) => {
            onEditMemo(editedMemo);
            setSelectedMemoId(editedMemo.id);
            handleBack();
          }}
        />
      )}
    </div>
  );
};

export default ChatMemoDrawer;
